import { render } from "./PlatformSettings.vue?vue&type=template&id=946103ac&scoped=true"
import script from "./PlatformSettings.vue?vue&type=script&lang=js"
export * from "./PlatformSettings.vue?vue&type=script&lang=js"

import "./PlatformSettings.vue?vue&type=style&index=0&id=946103ac&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-946103ac"]])

export default __exports__